import { render, staticRenderFns } from "./BookingEdit.vue?vue&type=template&id=18959be2&scoped=true&"
import script from "./BookingEdit.vue?vue&type=script&lang=js&"
export * from "./BookingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18959be2",
  null
  
)

export default component.exports